// export const baseUrl = 'http://localhost:8000'
export const baseUrl = 'https://endpoint.qubikahotel.com'